import RandomList from './RandomList';
export default RandomList;



// WEBPACK FOOTER //
// ./src/components/RandomCountries/RandomList/index.js